import { DynamicTankIcon } from 'app/agriculture/routes/Tanks/TankIndicator/DynamicTankIcon';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { Skeleton } from '@mui/material';
import './TankIndicator.scss';

export function TankIndicatorSkeleton() {
    return (
        <div className="TankIndicator">
            <DynamicTankIcon level={null} />
            <StatDisplay name="Level" value={<Skeleton variant="text" width={24} />} unit="%" />
        </div>
    );
}
